// Hotspot section (sections/hotspot.liquid): moves the blocks into place. Hotspot markers go onto the image, Benefit
// blocks to the side of the image (right or left), buttons below the benefits (desktop, right/left) or below everything, every other block to the header
// (above everything, or on desktop at the top of the benefits column).
(() => {
  if (window.themeHotspot) return;
  window.themeHotspot = true;
  const desktop = window.matchMedia('(min-width: 750px)');

  // Full width image: 100vw counts the scrollbar (Windows), so the CSS uses --viewport-width (the page without it) (also in scrolling-images.js).
  if (!window.themeScrollbar) {
    window.themeScrollbar = true;
    const root = document.documentElement;
    const measure = () => root.style.setProperty('--viewport-width', `${root.clientWidth}px`);
    measure();
    new ResizeObserver(measure).observe(root);
  }

  const place = (hs) => {
    const source = hs.querySelector('[data-hs-source]');
    const header = hs.querySelector('[data-hs-header]');
    const spots = hs.querySelector('[data-hs-spots]');
    const actions = hs.querySelector('[data-hs-actions]');
    const left = hs.querySelector('[data-hs-left] [data-hs-benefits]');
    const right = hs.querySelector('[data-hs-right] [data-hs-benefits]');
    if (!source || !header || !spots || !actions || !left || !right) return;
    const layout = hs.dataset.benefitsDesktop;
    let pendingBreak = null;
    [...source.children].forEach((child) => {
      if (child.classList.contains('flow-break')) { pendingBreak = child; return; }
      let target = header;
      if (child.matches('[data-hotspot]')) target = spots;
      else if (child.classList.contains('benefit-block')) {
        target = layout === 'left' ? left : right;
      } else if (child.classList.contains('button-block')) target = actions;
      if (pendingBreak) { if (target !== spots) target.append(pendingBreak); else pendingBreak.remove(); pendingBreak = null; }
      target.append(child);
    });
    source.hidden = true;
    // "Close when the overlay is clicked" (section setting) for every popup (assets/modal.js reads it).
    hs.querySelectorAll('dialog.modal').forEach((dialog) => { dialog.dataset.overlayClose = hs.dataset.overlayClose; });
    hs.dataset.benefits = String(Boolean(left.children.length || right.children.length));
    hs.querySelector('[data-hs-left]').hidden = !left.querySelector('.benefit-block');
    hs.querySelector('[data-hs-right]').hidden = !right.querySelector('.benefit-block');
    // Buttons sit under the benefits on desktop, otherwise (mobile, or no benefits) below the whole layout.
    const side = layout === 'left' ? hs.querySelector('[data-hs-left]') : hs.querySelector('[data-hs-right]');
    if (desktop.matches && hs.dataset.benefits === 'true') side.append(actions);
    else hs.append(actions);
    // "Eyebrow, heading and text — desktop: Above the benefits": the header blocks open the benefits column.
    if (desktop.matches && hs.dataset.benefits === 'true' && hs.dataset.headerDesktop === 'benefits') side.prepend(header);
    else hs.querySelector('.hs__layout').before(header);
  };

  const all = (root = document) => root.querySelectorAll('.hs').forEach(place);
  all();
  document.addEventListener('shopify:section:load', (event) => all(event.target));
  desktop.addEventListener('change', () => all());
})();
